"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAppsEnabledAjax = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _ = require("../..");

var _createAjaxEpic = require("../../../redux/createAjaxEpic");

var _appSuiteApi = require("../appSuiteApi");

var _appSuiteRegistry = require("../appSuiteRegistry");

var _ILoading = require("../../../models/ILoading");

var getAppsEnabledAjax = function getAppsEnabledAjax(ajax) {
  return ajax.getJSON((0, _appSuiteApi.getEnabledAppsRequest)());
};

exports.getAppsEnabledAjax = getAppsEnabledAjax;

var getAppsEnabledAjaxSuccess = function getAppsEnabledAjaxSuccess(state, _action) {
  return (0, _objectSpread2.default)({}, state);
};

var getAppsEnabledAjaxFailed = function getAppsEnabledAjaxFailed(state, _action) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    enabledApps: {
      isLoading: false,
      loadingState: _ILoading.LoadingState.loaded,
      value: {}
    }
  });
};

(0, _createAjaxEpic.addAjaxEpic)(_appSuiteRegistry.appSuiteRegistry, _.AppSuiteActions.getAppsEnabled, getAppsEnabledAjax, {
  statePropertyName: 'enabledApps',
  isLoadable: true,
  showErrorAsToast: false,
  loadingSuccessReducer: getAppsEnabledAjaxSuccess,
  loadingFailedReducer: getAppsEnabledAjaxFailed
});